module.exports = __webpack_public_path__ + "img/share_1.6bbdd25c.svg";